import { toDateTimestamp } from '../logical/date-value.js';
import { t } from '../logical/index.js';
import { createStatisticConfig } from './create.js';
import type { StatisticsConfig } from './types.js';

const fmt = (ms: number) => new Date(ms).toLocaleDateString();

// values arrive as a bare timestamp (`date`) or as a range object (`date-range`)
const validDates = (data: ReadonlyArray<unknown>): number[] => {
  const out: number[] = [];
  for (const v of data) {
    const ts = toDateTimestamp(v);
    if (ts != null) out.push(ts);
  }
  return out;
};

export const dateStatsFunctions: StatisticsConfig[] = [
  createStatisticConfig({
    group: 'More options',
    type: 'earliest-date',
    menuName: 'Earliest date',
    displayName: 'Earliest',
    dataType: t.date.instance(),
    impl: data => {
      const xs = validDates(data);
      if (xs.length === 0) return 'None';
      return fmt(Math.min(...xs));
    },
  }),
  createStatisticConfig({
    group: 'More options',
    type: 'latest-date',
    menuName: 'Latest date',
    displayName: 'Latest',
    dataType: t.date.instance(),
    impl: data => {
      const xs = validDates(data);
      if (xs.length === 0) return 'None';
      return fmt(Math.max(...xs));
    },
  }),
  createStatisticConfig({
    group: 'More options',
    type: 'date-range',
    menuName: 'Date range',
    displayName: 'Range',
    dataType: t.date.instance(),
    impl: data => {
      const xs = validDates(data);
      if (xs.length === 0) return 'None';
      return `${fmt(Math.min(...xs))} – ${fmt(Math.max(...xs))}`;
    },
  }),
];
